// Copyright (c) 2016 Deere & Company

import './dealer-settings.scss';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import React, {PropTypes} from 'react';
import {
    createErrorObject,
    errorAlertBar
} from '../../../shared/services/alert-bar';
import CheckboxListWithLabel from '../../../shared/components/checkbox-list-with-label';
import ConfirmationModal from '../../../shared/components/confirmation-modal';
import DealerSettingsModel from '@deere/cps-it.warranty-model-factory/lib/dealer-settings';
import Modal from '../../../product/shared/state/modal';
import OptionsDropDown from '../../../shared/components/options-drop-down';
import SettingsHeader from '../../shared/components/settings-header';
import {addCollectionLabels} from '../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../shared/services/hashmap';
import {getToggleLabel} from '../../shared/services/user-settings-helpers';
import {isDealerSettingsValid} from '../services/form-validation';
import {withRouter} from 'react-router';

let unListen;

function handleDisplayFormatChange(decimalKey) {

    this.actions.updateDealerDisplayFormat(decimalKey, this.userDealerSettings.displayFormat.allowedDisplayFormats);

}

function handleAccountsChange(account, isSelected) {

    this.actions.updateDealerAccounts(account, isSelected);

}

function handleUserSettingsSave() {

    this.actions.updateUserSettings();

}

function handleToggleAll() {

    this.actions.toggleAllAccounts(this.userDealerSettings.accounts.allowedAccounts);

}

function handleConfirmSaveModal() {

    this.actions.confirmSaveModal(this.nextLocation);

}

function handleCloseConfirmationModal() {

    this.actions.closeConfirmSaveModal(this.nextLocation);

}

class DealerSettings extends React.Component {

    componentWillMount() {

        this.props.actions.updateIsSaved(true);

        unListen = this.props.router.listenBefore(nextLocation => this.props.actions.handleOnPageLeave(nextLocation, this.props));

        if (this.props.userDealerSettings.accounts.allowedAccounts.length === 0) {

            errorAlertBar(createErrorObject(this.props.intl.formatMessage({id: 'NO_DEALERS_MAPPED'})));

        }

    }

    componentWillUnmount() {

        unListen();

    }

    render() {

        return (
            <section className='dealer-settings'>
                <SettingsHeader
                    className='dealer-settings-header'
                    isSaveDisabled={this.props.isSaved || !isDealerSettingsValid(this.props.userDealerSettings.accounts)}
                    onSave={this.props::handleUserSettingsSave}
                    title='DEALER_LOCATION'
                />
                <section className='dealer-settings-panel'>
                    <OptionsDropDown
                        className='display-format'
                        isPlaceholderTranslated={false}
                        label='DISPLAY_FORMAT'
                        onChange={this.props::handleDisplayFormatChange}
                        optionDisplayAttributes={['value']}
                        optionKey='key'
                        options={this.props.userDealerSettings.displayFormat.allowedDisplayFormats}
                        placeholder='SELECT_DISPLAY_FORMAT'
                        selectedValue={this.props.userDealerSettings.displayFormat.key}
                    />
                    <div className='locations'>
                        <CheckboxListWithLabel
                            className='dealer-locations'
                            initialState={createHashMap(this.props.userDealerSettings.accounts.selectedAccounts, 'account')}
                            label='LOCATIONS'
                            list={addCollectionLabels(this.props.userDealerSettings.accounts.allowedAccounts)}
                            onChange={this.props::handleAccountsChange}
                            uid='account'
                        />
                        {
                        this.props.userDealerSettings.accounts.allowedAccounts.length ?
                            <button
                                onClick={this.props::handleToggleAll}
                                type='button'
                            >
                                <FormattedMessage id={getToggleLabel(this.props.userDealerSettings.accounts.selectedAccounts)}/>
                            </button> : null
                        }
                    </div>
                </section>
                <ConfirmationModal
                    confirmMessage='DO_YOU_WANT_TO_SAVE_YOUR_CHANGES'
                    isOpen={this.props.confirmSaveModal.isVisible}
                    onClose={this.props::handleCloseConfirmationModal}
                    onConfirm={this.props::handleConfirmSaveModal}
                    title='SAVE_CHANGES'
                />
            </section>
        );

    }

}

DealerSettings.displayName = 'DealerSettings';
DealerSettings.propTypes = {
    actions: PropTypes.object.isRequired,
    confirmSaveModal: PropTypes.instanceOf(Modal).isRequired,
    intl: intlShape.isRequired,
    isSaved: PropTypes.bool.isRequired,
    nextLocation: PropTypes.string.isRequired,
    router: PropTypes.object.isRequired,
    userDealerSettings: PropTypes.instanceOf(DealerSettingsModel).isRequired
};

export default withRouter(injectIntl(DealerSettings));



// WEBPACK FOOTER //
// ./src/user/dealer-settings/components/dealer-settings.js